import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useMemo, useState } from 'react';
import MyTextField from '../../utils/MyTextField';
import MySelect from '../../utils/MySelect';

//UnoButton
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import { unoTheme } from "../../../assets/styles/unoTheme";
import UnoButton from '../../utils/UnoButton';

//RadioGroup

//BoostrapInput

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

//Grid
import { Grid } from "@material-ui/core";


import CircularProgress from '@material-ui/core/CircularProgress';

import ConfirmActionRightContent from './ConfirmActionRightContent';

import moment from 'moment';
import { POSSIBLE_NO_VINC_ACCOUNTS_NUMBERS } from '../../../controllers/AccountController';
import { isValidCnpj } from '../../utils/utils';
import { DistributorsAPI } from '../../../API/distributors';
import { InstituitionAPI } from '../../../API/instituition';

const useStyles = makeStyles((theme) => ({
    root: {
        //height: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },

    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3)
    },

    main: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        textAlign: 'left',

        '& .MuiPaper-root': {
            height: 'calc(100% - 184px)',
        }
    },

    accordionAccount: {
        marginBottom: theme.spacing(2),
    },
    accordionSummary: {
        //background: lemaTheme.secondaryColor,
        //color: "white",
        '&:nth-child(1)': {
            marginBottom: '10px'
        }
    },
    iconWhite: {
        color: 'white',
    },
    accordionDetails: {
        background: '#ffffff'
    },
    formControl: {
        //margin: theme.spacing(1), 
        width: '100%',
        textAlign: 'left'
    },
    inputsAccount: {
        width: '100%',
    },
    cellIcon: {
        padding: '0px'
    },
    formNewApplication: {
        width: "100%",
    },
    progressInput: {
        width: '20px !important',
        height: '20px !important',
    },
    itemRegime: {
        fontSize: "0.6em !important",
    },
    alignLeft: {
        textAlign: "left",
        '& fieldset': {

            '& legend': {
                fontSize: '0.9em !important',
            }

        }

    },
    legendeRadioGroup: {
        fontSize: '0.9em !important',
    },
    headerSearch: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: 'center',
        padding: theme.spacing(2),

        '& .MuiTypography-root': {
            marginBottom: '0px',
        }
    },
    headerDetail: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },
    leftHeaderDetail: {
        display: "flex",
        alignItems: "baseline",
    },
    input: {
        display: 'none',
    },
    green: {
        color: "green",
        fontWeight: 'bold'
    },
    red: {
        color: "red",
        fontWeight: 'bold'
    },
    blue: {
        color: "blue",
        fontWeight: 'bold'
    },
    spacingLeft1: {
        marginLeft: theme.spacing(1)
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },
    hiddenIcon: {
        visibility: 'hidden',
    },
    bottom: {

        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        justifyContent: 'flex-end',

        '& .bottomButtons': {
            paddingTop: theme.spacing(2),
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
        }

    },
    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },

}));

export default function NewInstituition(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const currentUser = useSelector(state => state.currentUser)
    const clientOn = useSelector(state => state.clientOn)

    const { content } = props

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');

    const [confirmingAction, setConfirmingAction] = useState(false);

    //form            
    const [submitted, setSubmitted] = useState('');

    const [inputCod, setInputCod] = useState('');
    const [inputDescription, setInputDescription] = useState('');
    const [inputStatusBacen, setInputStatusBacen] = useState('');


    function loadInfos(data) {

        const { cod, description, status_bacen } = data;
        setInputCod(cod);
        setInputDescription(description);
        setInputStatusBacen(status_bacen || '');

    }

    async function doSave() {

        setValidationMessage('')
        setSubmitted(true);
        setOpenBackdrop(true)

        const { update: isUpdate } = content;


        if (inputCod != ""
            && inputCod?.length === 3
            && inputDescription != "") {

            const instituition = {
                description: inputDescription,
                cod: inputCod,
                status_bacen: inputStatusBacen || null,
            }

            const response = await InstituitionAPI.save({
                ...instituition,
                id: isUpdate ? content.data.id : null
            });

            if (response.success) {

                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'success',
                    message: `Instituição ${isUpdate ? "atualizada" : "criada"} com sucesso!`
                }))

                dispatch(allActions.rightContentActions.update())

            } else {

                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'error',
                    message: `Erro ao ${isUpdate ? "atualizar" : "criar"} a instituição: ` + response.body.message
                }))


            }



        }

        setOpenBackdrop(false)




    }

    useEffect(() => {

        if (clientOn && clientOn.client) {

            if (content.data)
                loadInfos(content.data);

        }
    }, []);


    return (
        <div className={classes.root}>

            {
                !confirmingAction ?
                    <>
                        <div className={classes.header}>
                            <IconButton
                                className={classes.hiddenIcon}>
                                <ArrowBackIcon />
                            </IconButton>


                            <div>
                                <Typography
                                    variant={'h6'}
                                    align={'left'}>

                                    {content.update ? "Editar instituição" : "Cadastrar instituição"}

                                </Typography>

                            </div>


                            <IconButton
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                                <CloseIcon />
                            </IconButton>

                        </div>


                        <div className={classes.main}>
                            <Grid container spacing={2}>

                                <Grid item lg={12} md={12} sm={12} xs={12} >

                                    <MyTextField
                                        id="instituition-cod"
                                        outerlabel={'Código'}
                                        value={inputCod}
                                        onChange={(value) => setInputCod(value)}
                                        placeholder={'Insira o código'}
                                        validator={(inputCod == "" || inputCod.length !== 3) && submitted}
                                        helperText="Informe um código válido (3 caracteres)"
                                        mask={["onlyNumbers"]} />

                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MyTextField
                                        id="instituition-description"
                                        outerlabel={'Descrição da instituição'}
                                        value={inputDescription}
                                        onChange={(value) => setInputDescription(value)}
                                        validator={!inputDescription && submitted}
                                        helperText="Informe uma descrição"
                                        placeholder={'Insira a Descrição'} />

                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MySelect
                                        outerlabel={'Status Bacen'}
                                        value={inputStatusBacen}
                                        initblank={'true'}
                                        onChange={(e) => setInputStatusBacen(e.target.value)}
                                        //Só S1 e S2 se cadastram: a instituição que não é nenhum
                                        //dos dois fica com o campo vazio, de propósito. Numa
                                        //entidade já vinculada, portanto, o vazio é resposta —
                                        //"não é S1/S2" — e não omissão. Vincular é afirmar o
                                        //segmento, e é disso que a R9 (art. 21) depende
                                        options={['S1', 'S2'].map((status) => (
                                            <option key={'status-bacen-' + status} value={status}>
                                                {status}
                                            </option>
                                        ))}

                                    />

                                </Grid>

                            </Grid>

                            <br />
                            <div className={classes.bottom}>

                                {
                                    validationMessage != '' ?
                                        <Typography className={classes.validationMessage}>
                                            {validationMessage}
                                        </Typography>
                                        : null

                                }


                                <div className={'bottomButtons'}>

                                    {/* <UnoButton
                                        className={
                                            !content.update ? classes.hiddenIcon : null}
                                        onClick={() => setConfirmingAction(true)}
                                        type='errorClean'>
                                        {"Excluir"}
                                    </UnoButton> */}

                                    <UnoButton
                                        float={"right"}
                                        onClick={() => doSave()}
                                        type={content.update ? 'success' : 'primary'}>
                                        {content.update ? "Atualizar" : "Criar"}
                                    </UnoButton>


                                </div>



                            </div>

                        </div>
                    </>

                    :
                    null

                // <ConfirmActionRightContent
                //     message={`Tem certeza que quer excluir 
                //     este distribuidor?`}
                //     handleCancel={handleCancel}
                //     handleConfirm={handleConfirm}
                // />
            }


            {
                openBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                    </div> : null
            }


        </div>
    );
}



